<template lang="pug">
transition(name="dawn-modal" @afterEnter='onshow')
  .dawn-modal-mask(@click="close", v-if="show")
    .dawn-modal-container(@click.stop)
      .dawn-modal-top
        span.close-icon(@click="close")
          i.fal.fa-times
      .dawn-modal-header
        h3.title {{title}}
        p.subtitle {{subtitle}}
      slot(name="body")
      .dawn-modal-footer.text-right
        slot(name="footer")
        div(v-if="!hasSlotFooter")
          ed-button.btn.btn-secondary(@click="close", v-if="secondaryButton != 'false'") {{secondaryButton}}
          ed-button.btn.btn-primary(@click="close", v-if="primaryButton != 'false'") {{primaryButton}}
</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

import { EventBus } from '@/event-bus'

export default {
  name: 'ed-modal',

  props: {
    show           : { type: Boolean, default: false },
    title          : { type: String, required: true },
    subtitle       :         String,
    primaryButton  : { type: String, default: 'Ok' },
    secondaryButton: { type: String, default: 'Cancel' }
  },

  data() {
    return {
      body  : null,
      footer: null
    }
  },

  computed: {
    hasSlotFooter: function () { return this.$slots.footer }
  },

  mounted() {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode === 27) {
        this.close()
      }
    })
  },

  methods: {
    onshow: function() {
      EventBus.$emit('modal-show')
    },

    close: function () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(120, 87, 132, 0.3);
  transition: opacity .3s ease;
  overflow: auto;
  padding-bottom: 40px;
}

.dawn-modal-container {
  width: 500px;
  margin: 4rem auto 0;
  padding: 1rem 1.5rem;
  background: $canvas;
  border-radius: $border-radius;
  box-shadow: $box-shadow;
  transition: all .3s ease;

  h3.title {
    font-weight: $font-weight-extra-bold;
    font-size: $font-size-large;
  }

  p.subtitle {
    font-weight: normal;
    font-size: $font-size-base;
  }
}

.dawn-modal-top {
  text-align: right;
  margin-bottom: -45px;
  
  span.close-icon {
    font-weight: 100;
    color: $ink;
    margin-left: 2rem;
    text-align: right;
    &:hover {
      cursor: pointer;
    }
  }
}

.dawn-modal-body {
  margin: 1rem 0;
}

.text-right {
  text-align: right;
}

.dawn-modal-enter {
  opacity: 0;
}

.dawn-modal-leave-active {
  opacity: 0;
}

.dawn-modal-enter .dawn-modal-container,
.dawn-modal-leave-active .dawn-modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>



// WEBPACK FOOTER //
// index.vue?6577160c